var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHoverDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(-851 -76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M0,0H24V24H0Z",
    transform: "translate(851 76)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M10.076,11a1,1,0,1,1,0,2,1,1,0,1,1,0-2Zm3.848,0a1,1,0,1,1-1.075,1A1.037,1.037,0,0,1,13.924,11Zm4.967-9A2.136,2.136,0,0,1,21,4.163V23l-2.211-2-1.245-1.176-1.317-1.25.546,1.943H5.109A2.136,2.136,0,0,1,3,18.359V4.163A2.136,2.136,0,0,1,5.109,2H18.89Zm-3.97,13.713a3.747,3.747,0,0,0,3.148-1.6A14.282,14.282,0,0,0,16.587,8a5.02,5.02,0,0,0-2.89-1.1l-.144.168A6.8,6.8,0,0,1,16.114,8.4a8.263,8.263,0,0,0-3.1-1.008,8.527,8.527,0,0,0-2.077.02,1.033,1.033,0,0,0-.175.021,7.6,7.6,0,0,0-2.335.662c-.38.178-.607.305-.607.305a6.9,6.9,0,0,1,2.705-1.376l-.1-.126A5.019,5.019,0,0,0,7.536,8a14.283,14.283,0,0,0-1.481,6.121,3.718,3.718,0,0,0,3.137,1.6s.38-.472.69-.871a3.207,3.207,0,0,1-1.8-1.24,3.37,3.37,0,0,0,.287.179.132.132,0,0,0,.041.031c.031.022.062.032.093.053a6.063,6.063,0,0,0,.75.357,8.542,8.542,0,0,0,1.513.452,7.06,7.06,0,0,0,2.664.01,6.666,6.666,0,0,0,1.491-.451,5.906,5.906,0,0,0,1.183-.62,3.252,3.252,0,0,1-1.862,1.25c.309.4.68.85.68.85Z",
    transform: "translate(851 76)",
    fill: "#366eef"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverDiscord);
export default __webpack_public_path__ + "static/media/hoverDiscord.7d19a7525dff9e0f90ea2ae7b01a1972.svg";
export { ForwardRef as ReactComponent };